import Vue from 'vue';

import Clickoutside from './click-outside';
import Hover from './hover';
import Intersect from './intersect';
import IntersectGroup from './intersect-group';
import Resize from './resize';
import Ripple from './ripple';
import Scroll from './scroll';
import YmDisableKeys from './ym-disable-keys';

Vue.directive('click-outside', Clickoutside);
Vue.directive('intersect', Intersect);
Vue.directive('resize', Resize);
Vue.directive('scroll', Scroll);
Vue.directive('ripple', Ripple);
Vue.directive('hover', Hover);
Vue.directive('intersect-group', IntersectGroup);
Vue.directive('ym-disable-keys', YmDisableKeys);
